<template>
    <title>{{ informations.title }}</title>
    <link rel="icon" type="image/jpg" :href="'https://admin.asso-refuge.fr/images/' + informations.logo" />
<div class="fixedtoi">
    <header >
      

  <!-- Téléphone (clic direct) -->
  <i class="fas fa-envelope"></i>  lesadoptionsdelarun@gmail.com &nbsp;&nbsp;&nbsp;&nbsp;

  <!-- Réseaux sociaux -->
  <a href="https://www.facebook.com/p/Les-Oubli%C3%A9s-de-la-Run-Association-61552186153640/"
     target="_blank"
     style="color: white; text-decoration: none; margin-right: 30px;">
    <i class="fab fa-facebook-f"></i>
  </a>

    </header>



    <nav class="navbar navbar-expand-lg navbar-light bg-light " >
       <div class="navbar-container container-fluid">

        <a class="navbar-brand" href="/">
          <img
            :src="'https://admin.asso-refuge.fr/images/' + informations.logo"
            :alt="informations.title"
            width="75px"
          />
          {{ informations.title }}
        </a>

        <!-- Ici on applique la classe 'show' selon isCollapsed -->
        <div :class="['collapse', 'navbar-collapse', { show: !isCollapsed }]" id="navbarNav">
          <div class="navbar-nav">
            <router-link class="nav-link" :to="{ path: '/' }" @click="toggleNavbar">Notre association</router-link>

            <template v-for="page in pages" :key="page.id">
              <router-link
                class="nav-link"
                :to="'/' + (page.path_website ? page.path_website : page.path)"
                @click="toggleNavbar"
              >
                {{ page.name }}
              </router-link>
            </template>

            <router-link
              class="nav-link"
              :to="{ path: '/actualites' }"
              @click="toggleNavbar"
            >
              Actualités
            </router-link>

            <router-link
              class="nav-link"
              :to="{ path: '/', hash: '#contact' }"
              @click="toggleNavbar"
            >
              Contact
            </router-link>

            <a
              class="nav-link"
              href="https://www.helloasso.com/associations/les-oublies-de-la-run-association"
              target="_blank"
              rel="noopener noreferrer"
              @click="isCollapsed = true"
            >
              Soutenir
            </a>
          </div>
        </div>

        <!-- Le bouton déclenche toggleNavbar -->
        <button
          class="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          :aria-expanded="!isCollapsed"
          aria-label="Toggle navigation"
          @click="toggleNavbar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
</div>
    <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      pages: [],
      informations: {},
      isCollapsed: true, // Le menu est fermé au départ
    };
  },
  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getPages/${idSite}`)
      .then((response) => response.json())
      .then((data) => {
        const pagesModifiees = data.map((page) => {
          const newPage = { ...page };
          if (newPage.path === "services") newPage.path = "histoire";
          if (newPage.path_website === "services") newPage.path_website = "histoire";
          if (newPage.name === "Nos services") newPage.name = "Histoire";
          if (newPage.name === "Nos Animaux") newPage.name = "À l'adoption";
          return newPage;
        });
        this.pages = pagesModifiees;
      })
      .catch((error) => {
        console.error("Erreur requête pages:", error.message);
      });

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        
        this.informations = data[0] || {};
      })
      .catch((error) => {
        console.error("Erreur requête infos:", error.message);
      });
  },
  methods: {
    toggleNavbar() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>

<style src="../assets/css/refonte.css"></style>
